import { darken } from 'polished';
import styled from 'styled-components';
import bgHero from '~/assets/banners/bg-hero.jpg';

export const Container = styled.div`
  position: relative;
`;

export const FloatingButtons = styled.div`
  position: fixed;
  bottom: 24px;
  right: 20px;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  gap: 12px;

  a {
    width: 52px;
    height: 52px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition-duration: 0.3s;
    box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.3);
    text-decoration: none;

    :hover {
      transform: scale(1.08);
    }
  }

  .fab-whatsapp {
    background-color: #25d366;
    :hover {
      background-color: ${darken(0.05, '#25d366')};
    }
  }

  .fab-maps {
    background-color: #4285f4;
    :hover {
      background-color: ${darken(0.05, '#4285f4')};
    }
  }

  .fab-schedule {
    background-color: #be7e38;
    :hover {
      background-color: ${darken(0.08, '#be7e38')};
    }
  }
`;

export const Hero = styled.section`
  background-image: url(${bgHero});
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  min-height: 100vh;
  display: flex;
  align-items: center;

  .hero-cta {
    border-radius: 55px;
    background: rgba(255, 255, 255, 0.35);
    border: 1px solid rgba(255, 255, 255, 0.5);
    transition-duration: 0.3s;
    color: #fff;
    text-decoration: none;
    display: inline-flex;
    align-items: center;
    gap: 10px;
    padding: 14px 36px;
    font-size: 1.125rem;
    font-weight: 500;

    :hover {
      background: #fff;
      color: #202020;
      text-decoration: none;
    }
  }

  @media screen and (max-height: 750px) {
    padding-top: 120px;
  }
`;

export const GeoSeo = styled.section`
  background: #202020;
  padding: 80px 0;

  h2 {
    color: #be7e38;
    font-size: clamp(1.5rem, 3vw, 2rem);
    font-weight: 600;
    margin-bottom: 24px;
  }

  p {
    color: #c3c3c3;
    font-size: 1.0625rem;
    line-height: 1.75;
    margin-bottom: 16px;

    :last-child {
      margin-bottom: 0;
    }
  }
`;

export const ServicesGrid = styled.section`
  background: #f9f9f9;
  padding: 80px 0;

  h2 {
    color: #202020;
    font-size: clamp(1.5rem, 3vw, 2rem);
    font-weight: 600;
    margin-bottom: 48px;
    text-align: center;
  }

  .service-card {
    background: #fff;
    border-radius: 18px;
    padding: 28px 24px;
    border: 1px solid #ebebeb;
    box-shadow: 0px 2px 14px rgba(0, 0, 0, 0.04);
    transition-duration: 0.3s;
    height: 100%;

    :hover {
      box-shadow: 0px 8px 28px rgba(190, 126, 56, 0.14);
      border-color: rgba(190, 126, 56, 0.4);
      transform: translateY(-3px);
    }

    .icon-wrap {
      width: 56px;
      height: 56px;
      border-radius: 14px;
      background: rgba(190, 126, 56, 0.1);
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 16px;
      color: #be7e38;
    }

    h3 {
      color: #202020;
      font-size: 1rem;
      font-weight: 600;
      margin-bottom: 8px;
    }

    p {
      color: #666;
      font-size: 0.9rem;
      line-height: 1.6;
      margin-bottom: 0;
    }
  }
`;

export const TechnologySection = styled.section`
  background: #202020;
  padding: 80px 0;

  h2 {
    color: #fff;
    font-size: clamp(1.5rem, 3vw, 2rem);
    font-weight: 600;
    margin-bottom: 20px;
  }

  .lead-text {
    color: #c3c3c3;
    font-size: 1.0625rem;
    line-height: 1.7;
    margin-bottom: 32px;
  }

  .tech-list {
    list-style: none;
    padding: 0;
    margin: 0;

    li {
      color: #e0e0e0;
      padding: 14px 0;
      border-bottom: 1px solid rgba(255, 255, 255, 0.07);
      display: flex;
      align-items: center;
      gap: 14px;
      font-size: 1rem;

      :last-child {
        border-bottom: none;
      }

      .tech-icon {
        color: #be7e38;
        flex-shrink: 0;
      }
    }
  }

  .tech-footer {
    color: #c3c3c3;
    font-size: 0.9375rem;
    line-height: 1.7;
    margin-top: 28px;
  }

  .tech-badges {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
  }

  .tech-badge {
    background: rgba(190, 126, 56, 0.12);
    border: 1px solid rgba(190, 126, 56, 0.25);
    border-radius: 14px;
    padding: 24px 16px;
    text-align: center;

    .badge-label {
      color: #be7e38;
      font-size: 0.75rem;
      font-weight: 600;
      text-transform: uppercase;
      letter-spacing: 0.07em;
      margin-bottom: 8px;
    }

    .badge-value {
      color: #fff;
      font-size: 1.375rem;
      font-weight: 700;
      line-height: 1;
    }
  }
`;

export const AuthoritySection = styled.section`
  background: rgba(190, 126, 56, 0.07);
  padding: 80px 0;

  h2 {
    color: #995c19;
    font-size: clamp(1.5rem, 3vw, 2rem);
    font-weight: 600;
    margin-bottom: 20px;
  }

  p {
    color: #444;
    font-size: 1.0625rem;
    line-height: 1.75;
    margin-bottom: 16px;

    :last-of-type {
      margin-bottom: 32px;
    }
  }

  .experience-block {
    text-align: center;

    .number {
      font-size: clamp(4rem, 8vw, 6rem);
      font-weight: 800;
      color: #be7e38;
      line-height: 1;
    }

    .label {
      font-size: 1.0625rem;
      font-weight: 500;
      color: #995c19;
      margin-top: 8px;
    }
  }

  .btn-authority {
    background: #be7e38;
    color: #fff;
    border: none;
    border-radius: 55px;
    padding: 14px 40px;
    font-size: 1rem;
    font-weight: 500;
    transition-duration: 0.3s;
    display: inline-flex;
    align-items: center;
    gap: 10px;
    text-decoration: none;

    :hover {
      background: ${darken(0.08, '#be7e38')};
      color: #fff;
      text-decoration: none;
    }
  }
`;

export const FaqSection = styled.section`
  background: #f9f9f9;
  padding: 80px 0;

  h2 {
    color: #202020;
    font-size: clamp(1.5rem, 3vw, 2rem);
    font-weight: 600;
    text-align: center;
    margin-bottom: 48px;
  }

  .faq-item {
    background: #fff;
    border-radius: 16px;
    border: 1px solid #ebebeb;
    padding: 24px 28px;
    margin-bottom: 14px;
    transition-duration: 0.3s;

    :last-child {
      margin-bottom: 0;
    }

    :hover {
      border-color: rgba(190, 126, 56, 0.4);
    }

    h3 {
      color: #202020;
      font-size: 1rem;
      font-weight: 600;
      margin-bottom: 10px;
    }

    p {
      color: #555;
      font-size: 0.9375rem;
      line-height: 1.65;
      margin-bottom: 0;
    }
  }
`;

export const CtaFinal = styled.section`
  background: #202020;
  padding: 96px 0;
  text-align: center;

  h2 {
    color: #fff;
    font-size: clamp(1.75rem, 4vw, 2.5rem);
    font-weight: 700;
    margin-bottom: 16px;
  }

  p {
    color: #c3c3c3;
    font-size: 1.125rem;
    margin-bottom: 40px;
  }

  .cta-btn {
    background: #be7e38;
    color: #fff;
    border: none;
    border-radius: 55px;
    padding: 16px 52px;
    font-size: 1.125rem;
    font-weight: 600;
    transition-duration: 0.3s;
    display: inline-flex;
    align-items: center;
    gap: 10px;
    text-decoration: none;

    :hover {
      background: ${darken(0.08, '#be7e38')};
      color: #fff;
      text-decoration: none;
    }
  }

  small {
    color: rgba(255, 255, 255, 0.45);
    display: block;
    margin-top: 16px;
    font-size: 0.8125rem;
  }

  address.nap {
    color: #c3c3c3;
    font-style: normal;
    font-size: 0.9375rem;
    line-height: 1.8;
    margin: 48px 0 0;

    strong {
      color: #fff;
    }

    a {
      color: #be7e38;
      text-decoration: none;

      :hover {
        text-decoration: underline;
      }
    }
  }
`;
